export default __webpack_public_path__ + "static/media/026-sun.537b37ef.svg";